import React, { useEffect, useRef, useState } from "react";

function Paypal(props) {
  const paypalRef = useRef();
  const [buttonRendered, setButtonRendered] = useState(false);

  useEffect(() => {
    const loadPayPalScript = () => {
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&disable-funding=credit,card&vault=true`;
      script.id = "paypal-sdk";
      script.async = true;
      script.onload = renderPayPalButtons;
      document.body.appendChild(script);
    };

    const renderPayPalButtons = () => {
      if (buttonRendered) return;

      if (window.paypal && paypalRef.current) {
        paypalRef.current.innerHTML = "";

        window.paypal
          .Buttons({
            createOrder: (data, actions) => {
              return actions.order.create({
                intent: "CAPTURE",
                purchase_units: [
                  {
                    description: "License Fee",
                    amount: {
                      currency_code: "USD",
                      value: props.price,
                    },
                  },
                ],
              });
            },
            onApprove: async (data, actions) => {
              const order = await actions.order.capture();
              props.getPaypalDetail(order);
            },
            onError: (err) => {
              console.error("PayPal error:", err);
            },
          })
          .render(paypalRef.current);

        setButtonRendered(true);
      }
    };

    const existingScript = document.getElementById("paypal-sdk");
    if (!existingScript) {
      loadPayPalScript();
    } else {
      renderPayPalButtons();
    }
  }, [props.price]);

  return <div ref={paypalRef}></div>;
}

export default Paypal;
